import { render, staticRenderFns } from "./OperatingCenter.vue?vue&type=template&id=b4920b1e&"
import script from "./OperatingCenter.vue?vue&type=script&lang=js&"
export * from "./OperatingCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports